import { Box, Button, Stack, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import InstancesTab from './components/InstancesTab';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';
import { UserContext } from '../../components/shared/useUser';
import { useNavigate } from 'react-router-dom';

const InstancesPage = () => {
  const { t } = useTranslation('instances');
  const theme = useTheme();
  const navigate = useNavigate();

  const { hasPermissionTo } = useContext(UserContext);
  const [hasPermissionToCreateInstance, setHasPermissionToCreateInstance] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    setHasPermissionToCreateInstance(hasPermissionTo(['InstanceCreate', 'ConfigurationAdmin']));
  }, [hasPermissionTo]);

  const canViewInstances = hasPermissionTo(['InstanceView', 'ConfigurationAdmin']);

  if (!canViewInstances) {
    return null;
  }

  const onCreateNew = () => {
    navigate('/instances/create');
  };

  return (
    <PageArea>
      <Stack
        width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle subTitle={t('subtitle')}>{t('instances')}</PageTitle>
        </Box>

        {hasPermissionToCreateInstance && (
          <Box
            width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="primary"
              size="lg"
              startIcon={<SvgIcon><Plus fill='white' /></SvgIcon>}
              onClick={onCreateNew}
              sx={{
                mb: { xs: 4, md: 0 },
              }}
            >
              {t('createNew')}
            </Button>
          </Box>
        )}
      </Stack>
      
      <InstancesTab onCreateNew={onCreateNew} />
    </PageArea>
  );
};

export default InstancesPage;
